import { Typography } from '@axafr-btc-ds/typography';
import { Card } from 'components/card';
import styles from './Offer.module.css';
import { ColorHex } from '@axafr-btc-ds/colors';
import { Price } from 'components/price';
import { RenderIf } from 'components/render-if';
import { Formule } from 'services/pricing/Pricing.interface';

export const Offer = ({ coverageOption, tarifMensuel, isRecommended = false }: Pick<Formule, 'coverageOption' | 'tarifMensuel' | 'isRecommended'>) => {
    return (
        <Card className={ styles.host }>
            <RenderIf value={ isRecommended }>
                <div className={ styles.head } tabIndex={ -1 }>
                    <div>
                        <Typography className={ styles.headText } variant='body2'>Formule recommandée</Typography>
                    </div>
                </div>
            </RenderIf>
            <Typography id={ coverageOption?.code } className={ styles.title } variant='title3'>{ coverageOption?.label }</Typography>
            <div className={ styles.container }>
                <Typography className={ styles.priceTitle } color={ ColorHex.axablue } variant='body1'>à partir de</Typography>
                <Price amount={ tarifMensuel } suffix=' / mois' />
            </div>
        </Card>
    );
};
